import React,{useState,useEffect} from "react";
import { getFirestore, collection,getDocs } from "firebase/firestore";
import { app } from '../../Firebase/Firebaseapp';
import ShowCarsCard from "../components/ShowCarsCard";
import { useSelector } from "react-redux";

const fireStoreDb = getFirestore(app);



const ShowCars = () => {
  const { UpdateDepe } = useSelector((state) => state.FirebaseAuth);

  const [Cars,setCars]=useState([])
  const [isLoading,setLoading]=useState(true)
  const [searchQuery, setsearchQuery] = useState("");
  const [Brand, setBrands] = useState([])


  const allCars=()=>{
    return getDocs(collection(fireStoreDb,'CarDetails'));
  }
  const BrandsData = () => {
    return  getDocs(collection(fireStoreDb, 'Brands'));
}



 useEffect(()=>{
  console.log("show cars");
  setTimeout(()=>{
    setLoading(false)
  },800)
  allCars().then((cars)=>setCars(cars.docs));
  BrandsData().then((brands) => setBrands(brands.docs));
 },[UpdateDepe])

 console.log(searchQuery);


  return (
    <>

{

isLoading?
<div className="w-[100%] h-[82vh] flex justify-center items-center">
<div className="loader w-[20%] ">
        <div className="square-item"></div>
        <div className="square-item"></div>
        <div className="square-item"></div>
        <div className="square-item"></div>
    </div>
</div>
:
      <section className="relative py-16 bg-blueGray-50 w-[100%] min-h-[90vh] ShowcarsBack">
        <div className="w-full mb-12 px-4">
          <div
            className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded 
             bg-pink-900 text-white mx-auto backdrop-blur-sm bg-black/50"
          >
            <div className="rounded-t mb-0 px-4 py-3 border-0">
              <div className="flex flex-wrap items-center">
                <div className="relative w-full px-4 max-w-full flex-grow flex-1 ">
                  <h3 className="font-semibold text-lg text-white">Card Tables</h3>
                </div>
              </div>
            </div>
            <div className="block w-full overflow-x-auto ">
              <table className="items-center w-full bg-transparent border-collapse">
                <thead>
                  <tr>
                    <th className="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-pink-800 text-pink-300 border-pink-700">
                      Car Name
                    </th>
                    <th className="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-pink-800 text-pink-300 border-pink-700">
                      Company
                    </th>
                    <th className="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-pink-800 text-pink-300 border-pink-700">
                      

                   <select name="menu" className="card_Select bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 text-[17px] rounded-full outline-none"   value={searchQuery} onChange={(e)=>setsearchQuery(e.target.value)}>
                    <option selected value="All Brands">All Brands</option>
                    {
                    Brand && Brand.map((x, index) => {
                      return (
                        <option value={x.data().Brand} className=" bg-blue-900 hover:bg-blue-900" key={index} >{x.data().Brand}</option>
                      )
                    })
                  }

                  </select> 
                      
                     
                    </th>
                    <th className="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-pink-800 text-pink-300 border-pink-700">
                      Price
                    </th>
                    <th className="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-pink-800 text-pink-300 border-pink-700">
                      status
                    </th>
                    <th className="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left bg-pink-800 text-pink-300 border-pink-700">
                      Actions
                    </th>
                  </tr>
                </thead>

                <tbody>
                { Cars && Cars.filter((x)=>{
                  if(searchQuery==="All Brands"){
                    return x
                  }else if(x.data().Brand.includes(searchQuery)){
                    return x
                  }
                }).map((x,index)=>{
               return (
              
                 <ShowCarsCard x={x.data() } carsId={x.id} index={index} key={index}/>
           
                  )
              })
              }

                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

}
    </>
  );
};

export default ShowCars;
